import React, { useEffect, useRef } from 'react';
import styles from '../EditDiv/EditDiv.module.css';
import buttonStyles from '../YesNoButtonsCSS/YesNoButtons.module.css';
import BlueLogo from '../../assets/BlueLogo.png';
import { Grid, TextField, CircularProgress } from '@mui/material';
import { Form, FormikProvider } from 'formik';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import textfieldStyle from '../../GlobalStyles/styles';
import { useSnackbar } from 'notistack';
import { useDispatch, useSelector } from '../../redux/store';
import { submitTdgTopic } from '../../redux/slices/tdg';
import { useMsal } from '@azure/msal-react';

export default function TdgForm({ onSubmit, onClose }) {
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const tdgState = useSelector((s) => s.tdg || {});
  const { accounts } = useMsal();
  const account = accounts && accounts.length > 0 ? accounts[0] : null;
  const backdropRef = useRef(null);
  const formRef = useRef(null);

  const formik = useFormik({
    initialValues: { description: '', urgency: '3' },
    validationSchema: Yup.object().shape({
      description: Yup.string().required('Required'),
      urgency: Yup.string().required('Required'),
    }),
    onSubmit: async (values, { resetForm }) => {
      try {
        // include fixed topic type TDG
        const payload = {
          topicType: 'TDG',
          description: values.description,
          urgency: values.urgency,
          submitterEmail: account?.username || '',
        };
        await dispatch(submitTdgTopic(payload));
        enqueueSnackbar('TDG submitted. Thank you!', { variant: 'success' });
        resetForm();
        if (typeof onSubmit === 'function') onSubmit(payload);
        if (typeof onClose === 'function') onClose();
      } catch (e) {
        enqueueSnackbar(e?.message || 'Failed to submit TDG', { variant: 'error' });
      }
    },
  });

  // Ensure modal opens scrolled to the top and content is top-aligned
  useEffect(() => {
    if (backdropRef.current) backdropRef.current.scrollTop = 0;
    if (formRef.current) formRef.current.scrollTop = 0;
  }, []);

  return (
    <div className={styles.backGround} ref={backdropRef}>
      <div
        className={styles.form}
        ref={formRef}
        style={{
          width: '600px',
          maxHeight: '80vh',
          overflowY: 'auto',
          justifyContent: 'flex-start',
          alignItems: 'stretch',
          paddingTop: 12,
          paddingBottom: 8,
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className={styles.momentTitle}>MOMENT</div>
        <div className={styles.sectionTitle}>Topics of Discussion (TDG)</div>

        <FormikProvider value={formik}>
          <Form autoComplete="off" noValidate style={{ width: '100%' }} onSubmit={formik.handleSubmit}>
            <Grid container sx={{ width: '100%' }}>
              <Grid item xs={4} sx={{ pr: 3 }}>
                <p className={styles.dataTitleV2}>1. Please describe the topic *</p>
              </Grid>
              <Grid item xs={8} sx={{ mt: 1 }}>
                <TextField
                  fullWidth
                  multiline
                  rows={4}
                  value={formik.values.description}
                  onChange={(e) => formik.setFieldValue('description', e.target.value)}
                  placeholder="Enter your answer"
                  sx={textfieldStyle}
                  error={Boolean(formik.touched.description && formik.errors.description)}
                />
              </Grid>
            </Grid>

            <Grid container sx={{ width: '100%', mt: 2 }}>
              <Grid item xs={4} sx={{ pr: 3 }}>
                <p className={styles.dataTitleV2}>2. Please state the urgency (1 is low, 5 is high) *</p>
              </Grid>
              <Grid item xs={8} sx={{ mt: 1 }}>
                <div style={{ display: 'flex', gap: 12 }}>
                  {[1, 2, 3, 4, 5].map((n) => (
                    <div
                      key={n}
                      onClick={() => formik.setFieldValue('urgency', String(n))}
                      style={{
                        padding: '8px 12px',
                        borderRadius: 4,
                        border: formik.values.urgency === String(n) ? '2px solid #3C96D4' : '1px solid #ddd',
                        cursor: 'pointer',
                        background: formik.values.urgency === String(n) ? '#e9f5fb' : '#fff',
                      }}
                    >
                      {n}
                    </div>
                  ))}
                </div>
              </Grid>
            </Grid>

            <div className={styles.updateAndCancel} style={{ marginTop: 16 }}>
              <div
                className={styles.updateButton}
                type="submit"
                onClick={() => {
                  if (!tdgState.isSubmitting) formik.handleSubmit();
                }}
                aria-disabled={tdgState.isSubmitting}
              >
                <div className={buttonStyles.YesButtonComponentStyling}>
                  {tdgState.isSubmitting ? <CircularProgress size={18} style={{ color: '#fff' }} /> : 'SUBMIT'}
                </div>
              </div>
              <div className={styles.cancelButton} onClick={onClose}>
                <div className={buttonStyles.NoButtonComponentStyling}>CANCEL</div>
              </div>
            </div>
          </Form>
        </FormikProvider>

        <img className={styles.blueLogo} src={BlueLogo} alt="BlueLogo" style={{ alignSelf: 'center' }} />
      </div>
    </div>
  );
}


